module.exports = __webpack_public_path__ + "img/089-cloudy.78a60b2d.svg";